export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-37.a879ea44.jpg";